import * as Sentry from '@sentry/angular';
import { LogOptions } from './advanced-debugging.utilities';

export function logToConsole(functionName: string, data?: any, options: LogOptions = {}): void {
	if (window.location.hostname !== 'localhost') return;

	const {
		logStyle = 'color: red; font-weight: bold; padding: 2px 6px; border-radius: 4px;',
		groupLabel,
		groupStyle = 'color: gray; font-weight: bold; background: #eee; padding: 2px 6px; border-radius: 4px;',
		expanded,
		forceRoot = false,
	} = options;

	if (forceRoot) {
		Object.keys(logToConsole.openGroups).forEach(closeLogGroup);
	}

	if (groupLabel) {
		if (!logToConsole.openGroups[groupLabel]) {
			expanded ? console.group(`%c${groupLabel}`, groupStyle) : console.groupCollapsed(`%c${groupLabel}`, groupStyle);
			logToConsole.openGroups[groupLabel] = true;
		}
	}

	console.log(`%c${functionName}`, logStyle, ...(data !== undefined ? [data] : []));
}

logToConsole.openGroups = {} as Record<string, boolean>;

export function closeLogGroup(groupLabel: string): void {
	if (logToConsole.openGroups[groupLabel]) {
		console.groupEnd();
		delete logToConsole.openGroups[groupLabel];
	}
}

/** Legacy helper; prefer {@link AdvancedDebugging.captureError} with `tags.operation`. */
export function captureError(functionName: string, error: any, additionalData: any = {}, options: LogOptions = {}): void {
	const operation = typeof additionalData?.tags?.operation === 'string' ? additionalData.tags.operation : functionName;

	Sentry.withScope(scope => {
		scope.setTag('operation', operation);
		if (additionalData?.tags) {
			for (const [key, value] of Object.entries(additionalData.tags)) {
				if (key !== 'operation') {
					scope.setTag(key, String(value));
				}
			}
		}
		for (const [key, value] of Object.entries(additionalData)) {
			if (key !== 'tags') {
				scope.setExtra(key, value);
			}
		}
		scope.setExtra('functionName', functionName);
		Sentry.captureException(error);
	});

	logToConsole(`Error in ${functionName}`, error, {
		...options,
		logStyle: 'color: red; font-weight: bold; padding: 2px 6px; border-radius: 4px;',
	});
}
